
import React from 'react';
import PropTypes from 'prop-types';
import tw from 'tailwind-styled-components';
import { SectionContainer } from '../../pages/shared.styled';

const HeaderContainer = tw.section`bg-gray-lighter`;

export default function PageHeader({imageUrl = "", backgroundSize = "contain", backgroundPosition = "center center", backgroundColor = "transparent", children, className = ""}) {
  return (
    <HeaderContainer className={`overflow-hidden ${className}`}
      style={{ position: "relative", height: "180px",
      backgroundImage: `url(${imageUrl})`,
      display: 'flex',
      backgroundSize,
      backgroundPosition,
      backgroundColor,
      backgroundRepeat: "no-repeat" }}
      >
      <SectionContainer className="flex content-center items-center h-full w-full ">
        <div className='font-normal text-white text-4xl leading-snug'>{children}</div>
      </SectionContainer>
    </HeaderContainer >
    );
}

PageHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  imageUrl: PropTypes.string,
  backgroundSize: PropTypes.string,
  backgroundPosition: PropTypes.string,
  backgroundColor: PropTypes.string,
  className: PropTypes.string
}
